import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, IconButton, Icon, Message } from 'rsuite'
import AttachFilesForm from '../attachfiles/AttachFilesForm'
import AttachFilesView from '../attachfiles/AttachFilesView'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import EditButton from '../../components/buttons/editButton/EditButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import {
  getDownload,
  getAttachments,
  saveAttachments,
  updateAttachments,
  deleteAttachments,
  saveProgressFeedback,
  updateProgressFeedback,
  deleteProgressFeedback,
} from '../../redux/actions/projectProgress'
import { startLoading, doneLoading } from '../../utils/loading'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import CommentForm from './CommentForm'
import CommentView from './CommentView'
import ButtonPanel from '../ButtonPanel'
import InfoMessage from '../../components/message/infoMessage/InfoMessage'
import WarningMessage from '../../components/message/WarningMessage/WarningMessage'

export default function AttachFilesWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEdit, onChangeIsEdit, infoMessage } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(_schema)
  const [progressId, setProgressId] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // let progressId = location.search.substring(1)
    let progressId = sessionStorage.getItem('param')?.substring(1)
    console.log('AttachFilesWidget', _schema, 'progressId', progressId)
    setProgressId(progressId)
    setFormSchema(_schema)
  }, [_schema])

  const handleUpdate = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsEditErr()
    try {
      console.log('update')
      const response = await updateAttachments(projectId, progressId, request)

      console.log('response', response)

      if (response) {
        console.log('call get.')
        const response = await getAttachments(projectId, progressId)
        console.log('getAttachments response', response)
        setFormSchema(response)
        setIsEditErr(false)
      } else {
        setIsEditErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsEditErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpload = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsUploadErr()
    try {
      console.log('upload')
      const response = await saveAttachments(projectId, progressId, request)
      console.log('response', response)

      if (response) {
        const _respornse = await getAttachments(projectId, progressId)
        setFormSchema(_respornse)
        setIsUploadErr(false)
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (schema) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError()
    try {
      console.log('call delete.')
      const status = await deleteAttachments(projectId, progressId, schema.id)
      if (status === 200) {
        console.log('call get.')
        const response = await getAttachments(projectId, progressId)
        console.log('getAttachments response', response)
        setFormSchema(response)
        setIsDeleteError(false)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await getDownload(projectId, fileObj.projectProgressId, fileObj.id)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await getDownload(projectId, fileObj.projectProgressId, fileObj.id)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const handleCallCommentService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      if (request.value.value || request.value.id) {
        if (request.value.value) {
          let response

          if (request.value.id) {
            console.log('call update.')
            response = await updateProgressFeedback(projectId, projectProgressId, request)
          } else {
            console.log('call save.')
            response = await saveProgressFeedback(projectId, projectProgressId, request)
          }

          console.log('response', response)
          if (response) {
            onChangeIsEdit(false)
            let _schema = formSchema
            _schema.comment = response
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        } else {
          let deleteResult = await deleteProgressFeedback(
            projectId,
            projectProgressId,
            request.value.id
          )

          if (deleteResult == 200) {
            const _schema = await getAttachments(projectId, progressId)
            console.log('getAttachments response', _schema)
            setFormSchema(_schema)
            onChangeIsEdit(false)
          } else {
            setIsError(true)
          }
        }
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onUpload = (data) => {
    console.log('onSubmit data', data)
    const file = data[formSchema.attachFiles.name]
    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    formData.append('Id', formSchema.id || '')
    formData.append('ProjectVersionId', projectId || '')
    formData.append('UserId', '')
    formData.append('ProjectProgressId', progressId || '')

    handleUpload(formData)
  }

  const onUpdate = (file, newName) => {
    console.log('onUpdate file', file, 'newName: ', newName)

    file['projectVersionId'] = projectId
    file['projectProgressId'] = progressId
    file.label = newName

    console.log('file', file)
    handleUpdate(file)
  }

  const onDelete = (index) => {
    let datas = [...formSchema.attachFiles.value]
    handleDelete(datas[index])
  }

  const onSubmitComment = (data) => {
    console.log('onSubmitComment', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      masterSubjectId: formSchema.comment.masterSubjectId,
      value: {
        id: formSchema.comment.id,
        value: data.comment,
      },
    }

    console.log('request body', request)
    handleCallCommentService(request, progressId)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      bordered
      collapsible
      defaultExpanded
      style={{ marginBottom: '1em' }}
      ref={(section) => {
        setSection(section)
      }}
    >
      {infoMessage && <Message showIcon type="info" description={infoMessage} />}

      {formSchema?.comment?.enableEdit ? (
        <>
          <AttachFilesView
            schema={formSchema.attachFiles}
            autoHeight={formSchema?.attachFiles?.value.length <= 5}
            onDownload={onDownload}
            onPreview={onPreview}
          />
          <hr />
          {isEdit ? (
            <CommentForm
              schema={formSchema.comment}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          ) : (
            <div>
              <CommentView schema={formSchema.comment} />
            </div>
          )}
        </>
      ) : (
        <>
          <WarningMessage style={{ marginBottom: 10 }} message={formSchema?.comment?.value} />

          {isEdit ? (
            <AttachFilesForm
              schema={formSchema.attachFiles}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              onSubmit={handleSubmit(onUpload)}
              onDelete={onDelete}
              onUpdate={onUpdate}
              onDownload={onDownload}
              onPreview={onPreview}
              isEditErr={isEditErr}
              isUploadErr={isUploadErr}
              isDeleteError={isDeleteError}
              loading={isLoading}
            />
          ) : (
            <AttachFilesView
              schema={formSchema.attachFiles}
              onDownload={onDownload}
              onPreview={onPreview}
            />
          )}
        </>
      )}

      {showCommandButton && (
        <>
          <hr />
          {formSchema?.comment?.enableEdit ? (
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={
                formSchema?.comment?.enableEdit
                  ? formSchema?.comment?.buttonText
                  : formSchema.buttonText
              }
              onSave={handleSubmit(onSubmitComment)}
              onCancel={() => {
                onChangeIsEdit(!isEdit)
                setIsError(false)
              }}
              onEdit={() => {
                onChangeIsEdit(!isEdit)
                setIsError(false)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
          ) : (
            <>
              {!isEdit && showCommandButton && (
                <EditButton
                  onClick={() => {
                    onChangeIsEdit(!isEdit)
                    setIsEditErr(false)
                    setIsDeleteError(false)
                    setIsUploadErr(false)
                    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                  }}
                  disabled={isLoading}
                >
                  {'เพิ่ม/แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
                </EditButton>
              )}

              {isEdit && (
                <div>
                  <ViewButton
                    icon="backward"
                    onClick={() => {
                      onChangeIsEdit(!isEdit)
                      setIsEditErr(false)
                      setIsDeleteError(false)
                      setIsUploadErr(false)
                      scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                    }}
                    disabled={isLoading}
                  >
                    {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
                  </ViewButton>
                </div>
              )}
            </>
          )}
        </>
      )}
    </Panel>
  )
}
